import auth from '../api/auth';
import session from '../api/session';
import router from '../router';

import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  REMOVE_TOKEN,
  SET_TOKEN,
  LOGIN_MENU_OPENED,
} from './types';

const TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY';

const initialState = {
  authenticating: false,
  error: false,
  token: null,
  userMail: null,
  raisonError: null, // le message d'erreur de login retourné par l'API
};

const getters = {
  isAuthenticated: state => !!state.token,
};

const actions = {
  login({ commit }, { email, password }) {
    commit(LOGIN_BEGIN);
    return auth.login(email, password)
      .then(({ data }) => commit(SET_TOKEN, data.key))
      .then(() => commit(LOGIN_SUCCESS, email))
      .then(() => router.push('/cv'))
      // .catch(() => commit(LOGIN_FAILURE));
      .catch(function (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.log(error.response.data);
          // Test des erreurs retournées afin de l'afficher à l'utilisateur.
          // On alimente la raisonError de la LOGIN_FAILURE.
          var errorMessages = "";
            if (error.response.data) {
              console.log(error.response.data)
              
              for (var err in error.response.data) {
                console.log('error --> ' + error.response.data[err].join())
                errorMessages = errorMessages.concat(error.response.data[err].join())
              }
              console.log(errorMessages)
              console.log('errorMessages : ' + errorMessages)
          
              commit(LOGIN_FAILURE, errorMessages);
            }
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      });
  },
  resetERRORlogin({ commit }) {
    // Cette action permet de remettre à zero les erreurs de connexion précédentes.
    commit(LOGIN_MENU_OPENED);
  },

  logout({ commit, dispatch }) {
    return auth.logout()
      .then(() => commit(LOGOUT))
      // on enlève le token mais aussi, on réinitialise l'état de whoami!
      .finally(() => commit(REMOVE_TOKEN), dispatch('whoami/whoami_purge', null, { root: true }));
  },
  initialize({ commit }) {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);

    if (token) {
      commit(SET_TOKEN, token);
    } else {
      commit(REMOVE_TOKEN);
    }
  },
};

const mutations = {
  [LOGIN_MENU_OPENED](state) {
    state.error = false;
    state.raisonError = null;
  },
  [LOGIN_BEGIN](state) {
    state.authenticating = true;
    state.error = false;
    state.raisonError = null;
  },
  [LOGIN_FAILURE](state, raison) {
    state.authenticating = false;
    state.error = true;
    state.raisonError = raison
  },
  [LOGIN_SUCCESS](state, email) {
    state.authenticating = false;
    state.error = false;
    state.userMail = email;
  },
  [LOGOUT](state) {
    state.authenticating = false;
    state.error = false;
  },
  [SET_TOKEN](state, token) {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
    session.defaults.headers.Authorization = `Token ${token}`;
    state.token = token;
  },
  [REMOVE_TOKEN](state) {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    delete session.defaults.headers.Authorization;
    state.token = null;
    state.userMail = null;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
